// All imports same as before
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { toast } from "react-toastify";
import { useParams, useNavigate } from 'react-router-dom';
import AdvertiserPanel from './AdvertiserPanel';
import AdminNavbar from "./Layout/AdminNavbar";
import "../Styles/Advertiser.css";
import MacroHelper from '../../components/MacroHelper';

const AdvertisementEdit = () => {
   const access_token = localStorage.getItem("access_token");
   const { id } = useParams();
   const navigate = useNavigate();

   const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
   };

   const [editUser, setEditUser] = useState({});
   const [editname, setEditName] = useState({});
   const [ads_positionselect, setAds_positionselect] = useState([]);
   const [ads_categoryselect, setAds_categoryselect] = useState([]);
   const [user_ads_upload_type, setUser_ads_upload_type] = useState([]);
   const [advertisement_videos_upload, setAdvertisement_videos_upload] = useState("");

   const [validationErrors, setValidationErrors] = useState({});
   const [uploadType, setUploadType] = useState("");

   const titleInputRef = useRef(null);
   const uploadTypeRef = useRef(null);

   const fetchEditDetails = async () => {
      try {
         const res = await axios.get(`${process.env.REACT_APP_Baseurl}/advertiser/advertisement-edit/${id}`, { headers });
         const adData = res.data?.data?.Advertisements;
         setEditUser(adData);
         setEditName(adData);
         setAds_positionselect(res.data?.data?.ads_position_play);
         setAds_categoryselect(res.data?.data?.admin_ads_category);
         setUser_ads_upload_type(res.data?.data?.ads_upload_type);
         setUploadType(adData?.ads_upload_type || "");
      } catch (err) {
         console.error("Error loading ad details:", err);
      }
   };

   useEffect(() => {
      fetchEditDetails();
   }, []);

   // const handleInput = (e) => {
   //    const { name, value } = e.target;
   //    setEditUser({ ...editUser, [name]: value });
   //    if (name === "ads_upload_type") {
   //       setUploadType(value);
   //    }
   // };

   const handleInput = (e) => {
      const { name, value } = e.target;
      const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/;

      setEditUser(prev => ({ ...prev, [name]: value }));

      // Real-time validation only for ads_redirection_url when typing
      if (name === "ads_redirection_url") {
         if (value.trim() !== "" && !urlPattern.test(value.trim())) {
            setValidationErrors(prev => ({
               ...prev,
               [name]: "Redirection URL must start with http:// or https://"
            }));
         } else {
            setValidationErrors(prev => ({
               ...prev,
               [name]: ""
            }));
         }
      }

      if (name === "ads_upload_type") {
         setUploadType(value);
      }
   };




   const validateForm = () => {
      const errors = {};
      const urlPattern = /^(https?:\/\/)[^\s$.?#].[^\s]*$/;

      if (!editUser?.ads_name?.trim()) {
         errors.ads_name = "Advertisement Name is required.";
      }

      if (!editUser?.ads_upload_type) {
         errors.ads_upload_type = "Please select an Upload Type.";
      }

      if (!editUser?.ads_category) {
         errors.ads_category = "Please select a Category.";
      }

      if (editUser?.ads_upload_type === "tag_url") {
         if (!editUser?.ads_path?.trim() || !urlPattern.test(editUser?.ads_path)) {
            errors.ads_path = "Ad Tag URL must start with http:// or https://";
         }
      }

      if (editUser?.ads_upload_type === "ads_video_upload") {
         if (!advertisement_videos_upload && !editUser?.ads_path) {
            errors.ads_video = "Please upload a video or provide a path.";
         }
         if (editUser?.ads_redirection_url?.trim() && !urlPattern.test(editUser?.ads_redirection_url.trim())) {
            errors.ads_redirection_url = "Redirection URL must start with http:// or https://";
         }
      }

      setValidationErrors(errors);
      return Object.keys(errors).length === 0;
   };


   const [loading, setLoading] = useState(false);


   const handleStore = async (e) => {
      e.preventDefault();

      if (loading) return; // Prevent double clicks

      if (!validateForm()) {
         const firstErrorField = Object.keys(validationErrors)[0];
         if (firstErrorField === "ads_name") titleInputRef.current?.focus();
         else if (firstErrorField === "ads_upload_type") uploadTypeRef.current?.focus();
         return;
      }

      const payload = {
         ads_name: editUser?.ads_name,
         ads_position: editUser?.ads_position,
         ads_upload_type: editUser?.ads_upload_type,
         ads_category: editUser?.ads_category,
         ads_path: editUser?.ads_path,
         ads_redirection_url: editUser?.ads_redirection_url,
         status: editUser?.status,
         skip_duration: editUser?.skip_duration
      };

      try {
         setLoading(true);

         // Check upload limits using new centralized API
         // const limitCheckRes = await axios.get(
         //    `${process.env.REACT_APP_Baseurl}/advertiser/advertisement/upload-limit-status`,
         //    { headers }
         // );

         // const uploadStatus = limitCheckRes?.data?.data;

         // // Simple check: API handles all validation and returns final status
         // if (!uploadStatus?.can_upload) {
         //    toast.warning(uploadStatus?.message || "Your plan limit has been reached. Please upgrade your plan.");
         //    setLoading(false);
         //    navigate('/plans');
         //    return;
         // }

         await axios.patch(`${process.env.REACT_APP_Baseurl}/advertiser/advertisement-update/${id}`, payload, { headers });

         if (advertisement_videos_upload) {
            const formDataUpload = new FormData();
            formDataUpload.append("advertisement_videos_upload", advertisement_videos_upload);

            await axios.patch(`${process.env.REACT_APP_Baseurl}/advertiser/advertisement-upload/${id}`, formDataUpload, {
               headers: {
                  ...headers,
                  "Content-Type": "multipart/form-data",
               }
            });
         }
         toast.success("Advertisement updated successfully");
         setTimeout(() => navigate("/ads-list"), 800);
      } catch (error) {
         console.error(error);
         toast.error("Something went wrong while updating.");
      } finally {
         setLoading(false); // Re-enable button
      }
   };

   const handleMacroSelect = (newUrl) => {
      setEditUser(prev => ({ ...prev, ads_path: newUrl }));
      setValidationErrors(prev => ({ ...prev, ads_path: "" }));
   };

   const renderUploadFields = () => {
      if (uploadType === "tag_url") {
         return (
            <>
               <label className="mt-2 mb-2">Ad Tag URL <span className="errorred">*</span></label>
               <input
                  type="text"
                  className="form-control"
                  name="ads_path"
                  id="advertiserads_path"
                  value={editUser?.ads_path || ""}
                  placeholder="https://example.com/vast.xml?uid=[USER_ID]&ts=[TIMESTAMP]"
                  onChange={handleInput}
               />
               {validationErrors.ads_path && <small className="errorred">{validationErrors.ads_path}</small>}
               
               <MacroHelper 
                  onSelectMacro={handleMacroSelect} 
                  currentUrl={editUser?.ads_path || ""} 
               />
            </>
         );
      }

      if (uploadType === "ads_video_upload") {
         return (
            <>

               <label className="mt-2">Upload Video <span className="errorred">*</span></label>

               <input type="text" id="advertiserads_pathcopycopy" className="form-control mt-3 mb-3" value={editUser?.ads_path || ""} readOnly />

               <input
                  type="file"
                  id="advertiserfileads_video_upload"
                  accept="video/*"
                  className="form-control"
                  onChange={(e) => setAdvertisement_videos_upload(e.target.files[0])}
               />
               {validationErrors.ads_video && <small className="errorred">{validationErrors.ads_video}</small>}

               <label className="mt-3  mb-2">Redirection URL
                  {/* <span className="errorred">*</span> */}
               </label>
               <input
                  type="text"
                  className="form-control"
                  name="ads_redirection_url"
                  id="advertiserads_redirection_url"
                  value={editUser?.ads_redirection_url || ""}
                  onChange={handleInput}
               />
               {validationErrors?.ads_redirection_url && (
                  <small className="errorred">{validationErrors?.ads_redirection_url}</small>
               )}
            </>
         );
      }

      return null;
   };

   return (
      <AdvertiserPanel>
         <div className="container py-4">
            <AdminNavbar heading="Edit Advertisement" />


            <div className='col-lg-12 col-md-12 col-sm-12 row'>
               <div className='col-lg-6 col-md-6 col-sm-12'>
                  <div className="card p-4 mt-3">
                     <div className="mb-3">
                        <label className='mb-2'>Advertisement Name <span className="errorred">*</span></label>
                        <input
                           type="text"
                           name="ads_name"
                           id="advertiserads_name"
                           className="form-control"
                           value={editUser?.ads_name || ""}
                           onChange={handleInput}
                           ref={titleInputRef}
                        />
                        {validationErrors.ads_name && <small className="errorred">{validationErrors.ads_name}</small>}
                     </div>

                     <div className="mb-3">
                        <label className='mb-2'>Upload Type <span className="errorred">*</span></label>
                        <select
                           name="ads_upload_type"
                           id="advertiserads_upload_type"
                           className="form-select"
                           value={editUser?.ads_upload_type || ""}
                           onChange={handleInput}
                           onClick={(e) => setUploadType(e.target.value)}
                           ref={uploadTypeRef}
                        >
                           <option value="">Select Upload Type</option>
                           {user_ads_upload_type?.map((type, i) => (
                              <option key={i} value={type.value}>{type.name}</option>
                           ))}
                        </select>
                        {validationErrors.ads_upload_type && (
                           <small className="errorred">{validationErrors.ads_upload_type}</small>
                        )}
                     </div>

                     {renderUploadFields()}

                  </div>
               </div>
               <div className='col-lg-6 col-md-6 col-sm-12'>
                  <div className="card p-4 mt-3">

                     <div className="mb-3 mt-4">
                        <label className='mb-2'>Advertisement Position</label>
                        <select
                           className="form-select"
                           name="ads_position"
                           id="advertiserads_position"
                           value={editUser?.ads_position || ""}
                           onChange={handleInput}
                        >
                           <option value="">Select Position</option>
                           {ads_positionselect?.map((pos, i) => (
                              <option key={i} value={pos.value}>{pos.name}</option>
                           ))}
                        </select>
                     </div>

                     <div className="mb-3">
                        <label className='mb-2'>Advertisement Category <span className="errorred">*</span></label>
                        <select
                           className="form-select"
                           name="ads_category"
                           id="advertiserads_category"
                           value={editUser?.ads_category || ""}
                           onChange={handleInput}
                        >
                           <option value="">Select Category</option>
                           {ads_categoryselect?.map((cat, i) => (
                              <option key={i} value={cat.id}>{cat.name}</option>
                           ))}
                        </select>
                        {validationErrors.ads_category && (
                           <small className="errorred">{validationErrors.ads_category}</small>
                        )}

                        {editUser?.ads_upload_type === 'ads_video_upload' && <>
                           <label className='mt-2'>Advertisement Skip Time <span className="errorred"></span></label>
                           <input
                              type="number"
                              name="skip_duration"
                              id="skip_duration"
                              className="form-control"
                              value={editUser?.skip_duration || ""}
                              onChange={handleInput}
                              ref={titleInputRef}
                              placeholder='Enter the value in seconds'
                           />
                        </>}
                     </div>
                  </div>
               </div>


               <div className="text-end">
                  <button
                     className="btn btn-primary"
                     id="advertiser-update-button"
                     onClick={handleStore}
                     disabled={loading}
                  >
                     {loading ? "Submit" : "Submit"}
                  </button>
               </div>

            </div>
            {/* <div className="card p-4 mt-3">
               <div className="mb-3">
                  <label>Advertisement Name <span className="errorred">*</span></label>
                  <input
                     type="text"
                     name="ads_name"
                     className="form-control"
                     value={editUser?.ads_name || ""}
                     onChange={handleInput}
                     ref={titleInputRef}
                  />
                  {validationErrors.ads_name && <small className="errorred">{validationErrors.ads_name}</small>}
               </div>

               <div className="mb-3">
                  <label>Upload Type <span className="errorred">*</span></label>
                  <select
                     name="ads_upload_type"
                     className="form-select"
                     value={editUser?.ads_upload_type || ""}
                     onChange={handleInput}
                     onClick={(e) => setUploadType(e.target.value)}
                     ref={uploadTypeRef}
                  >
                     <option value="">Select Upload Type</option>
                     {user_ads_upload_type?.map((type, i) => (
                        <option key={i} value={type.value}>{type.name}</option>
                     ))}
                  </select>
                  {validationErrors.ads_upload_type && (
                     <small className="errorred">{validationErrors.ads_upload_type}</small>
                  )}
               </div>

               {renderUploadFields()}

               <div className="mb-3 mt-4">
                  <label>Advertisement Position</label>
                  <select
                     className="form-select"
                     name="ads_position"
                     value={editUser?.ads_position || ""}
                     onChange={handleInput}
                  >
                     <option value="">Select Position</option>
                     {ads_positionselect?.map((pos, i) => (
                        <option key={i} value={pos.value}>{pos.name}</option>
                     ))}
                  </select>
               </div>

               <div className="mb-3">
                  <label>Advertisement Category <span className="errorred">*</span></label>
                  <select
                     className="form-select"
                     name="ads_category"
                     value={editUser?.ads_category || ""}
                     onChange={handleInput}
                  >
                     <option value="">Select Category</option>
                     {ads_categoryselect?.map((cat, i) => (
                        <option key={i} value={cat.id}>{cat.name}</option>
                     ))}
                  </select>
                  {validationErrors.ads_category && (
                     <small className="errorred">{validationErrors.ads_category}</small>
                  )}
               </div>

               <div className="text-end">
                  <button className="btn btn-primary" onClick={handleStore}>Update Advertisement</button>
               </div>
            </div> */}
         </div>
      </AdvertiserPanel>
   );
};

export default AdvertisementEdit;
